/**
 * 日本站 - 企业 - 步骤1数据模板
 *
 * author: xiao.xu
 */
import formUtil from '_common/formSource/common/formUtil';
import { translate } from '_common/utils/language';
import UTIL from '_common/utils/util';

import getBase1 from '../person/P_BASE';

import getBase from './P_BASE';

function P1_INFO() {
  const base = getBase();
  const base1 = getBase1();
  const template = [
    {
      title: translate('jp.company.legal.fill'),
      subTitle: translate('jp.company.legal.fill.subTitle'),
      form: {
        companyName: base.companyName,
        companyNamePy: base.companyNamePy,
        businessType: base.businessType,
        business: base.business,
        haveCompanyNumber: base.haveCompanyNumber,
        noNumberReason: base.noNumberReason,
        companyNumber: base.companyNumber,
        officeType: base.officeType,
        registerCountry: base.registerCountry,
        establishedDate: base.establishedDate,
        employeeNumber: base.employeeNumber,
        income: base.income,
        registerCapital: base.registerCapital,
        liability: base.liability,
        siteUrl: base.siteUrl,
        residence: base.residence,
        postCode: base.postCode,
        addressData: base1.addressData,
        street: base1.street,
        location: base.location,
        companyPhone: base.companyPhone,
      },
    },
    // 法人
    {
      title: translate('jp.legal.fill'),
      form: {
        legalfirstName: base.legalfirstName,
        legalfirstNamePy: base.legalfirstNamePy,
        legalsex: base1.sex,
        legalbirthday: base1.birthDay,

        legalcountryCode: base1.countryCode,
        legalresidence: base1.residenceWithOtherCode,
        legalpostCode: base1.postCode,
        legaladdressData: base.legalAddress,
        legalstreet: base1.street,
        legallocation: base1.location,
        legalotherCountryCode: base1.otherCountryCode,
        legalotherPostCode: base1.otherPostCode,
        legalotherLocation: base1.otherLocation,
        legalurgentContactAddr: formUtil.replaceInfo(base, 'companyPhone', {
          title: translate('jp.comp.urgent.addr'),
        }),
        legalresidenceType: UTIL.deepCopy(base1.residenceType),
        legalresidenceValidity: UTIL.deepCopy(base1.residenceValidity),
      },
    },
    {
      title: '',
      subTitle: '',
      form: {
        isDirectorSameLegal: base.isDirectorSameLegal,
      },
    },
    {
      title: translate('jp.company.taker.fill'),
      subTitle: translate('jp.company.taker.explain'),
      form: {
        directordepartment: base.directordepartment,
        directorposition: base1.position,
        directorName: base.directorfirstName,
        directorNamePy: base.directorfirstNamePy,
        directorsex: base1.sex,
        directorbirthday: base1.birthDay,
        directorcountryCode: base1.countryCode,
        directorresidence: base1.residenceCode,
        directorpostCode: base1.postCode,
        directoraddressData: base.directorAddress,
        directorstreet: base1.street,
        directorlocation: base1.location,
        directorresidenceType: UTIL.deepCopy(base1.residenceType),
        directorresidenceValidity: UTIL.deepCopy(base1.residenceValidity),
      },
    },
    {
      title: '',
      subTitle: '',
      form: {
        isAdminOrganization: base.isAdminOrganization,
      },
    },
    {
      title: translate('jp.company.share.fill'),
      link: 'https://support.okj.com/hc/ja/articles/59000240497433',
      linkMessage: translate('user.okex.corporate.controller'),
      subtitle: null,
      form: {
        isExistShare: base.isExistShare,
        isOverFourShare: base.isOverFourShare,
        shareholders: base.shareholders, // 企业股东
      },
    },
  ];
  return template;
}

export default P1_INFO;
